import Swal from 'sweetalert2';
import { useSelector, useDispatch } from 'react-redux';
import { agregarLineaTemporal, agregarNodoDeLineaTemporal, agregarNodoDeCampoRelacional, cargarProyecto, addTimeLinePlace } from '../features/metadata/MetadataLogic'
import React, { useState } from "react";
import ModalOverlayGestionPersonas from "./ModalOverlayGestionPersonas";
import ModalOverlayGestionObjetos from "./ModalOverlayGestionObjetos";
import TotalTimelineslView from "./TotalTimelinesView";
import { Link } from 'react-router-dom';

// ICONS REACT ICONS
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle"
import { FaFileExport } from "@react-icons/all-files/fa/FaFileExport"
import { FaWindowClose } from "@react-icons/all-files/fa/FaWindowClose"
import { IoPersonCircleOutline } from "@react-icons/all-files/io5/IoPersonCircleOutline"
import { AiOutlineFundProjectionScreen } from "@react-icons/all-files/ai/AiOutlineFundProjectionScreen"
import { VscNewFolder } from "@react-icons/all-files/vsc/VscNewFolder"
import { ImFolderUpload } from "@react-icons/all-files/im/ImFolderUpload"
import { MdPlace } from "@react-icons/all-files/md/MdPlace";
import { FaBoxes } from "@react-icons/all-files/fa/FaBoxes";

export default function OptionsMenu({ timeLineID, setTimeLine }) {

    const dispatch = useDispatch()
    const project = useSelector((state) => state.project)
    //START - Para seleccionar los lugares (Campos Relacionales) ya creados --------------------------------------------
    const genPlaces = project.places;
    //END - Para seleccionar los lugares (Campos Relacionales) ya creados --------------------------------------------

    // Ordenar nodo del MOMENTO segun cantidad maxima en prioridades
    const individuos = project.timeLines[timeLineID].nodes;

    const maxLengthPriorities = [project.timeLines[timeLineID].priorityArr1, project.timeLines[timeLineID].priorityArr2
        , project.timeLines[timeLineID].priorityArr3]

    function mayor(arr) {
        let mayor = arr[0];
        let i = 1
        arr.forEach(element => {
            if (element > mayor)
                mayor = element
        })
        return mayor;
    }

    let maxLengthPriority = mayor(maxLengthPriorities)

    // Dice si hay objetos o no
    let objects = individuos.some(item => item.type === 'object')

    // Figura de la TL (Momento)
    let shape = "";
    // Status del individuo (0 Presente || 1 Ausente)
    let individualStatus = ""
    let borderDashes = false

    function setShapeByValue(value) {
        switch (value) {
            case ("1"):
                return "circle"
            case ("2"):
                return "ellipse"
            case ("3"):
                return "database"
            case ("4"):
                return "box"
            case ("5"):
                return "diamond"
            case ("6"):
                return "dot"
            case ("7"):
                return "square"
            case ("8"):
                return "triangle"
            case ("9"):
                return "triangleDown"
            case ("10"):
                return "star"
            case ("11"):
                return "hexagon"
            default: return "ellipse"
        }
    }


    const tlPlace = project.timeLines[timeLineID].tlPlace;
    const timeLines = useSelector((state) => state.project.timeLines)

    const reader = new FileReader()
    let timeLineName = ""

    const [showOverlay, setShowOverlay] = useState(false);
    const [showOverlayObj, setShowOverlayObj] = useState(false);
    const [showOverlayTotalTimeLinesView, setShowOverlayTotalTimeLinesView] = useState(false);

    let tlPlaceInput = ""

    const openOverlayGetionPersonas = () => {
        setShowOverlay(true);
    };

    const closeOverlay = () => {
        setShowOverlay(false);
    };

    const openOverlayGetionObjetos = () => {
        setShowOverlayObj(true);
    };

    const closeOverlayObj = () => {
        setShowOverlayObj(false);
    };



    const openOverlayTotalTimeLines = () => {
        setShowOverlayTotalTimeLinesView(true);
    };

    const closeOverlayTotalTimeLines = () => {
        setShowOverlayTotalTimeLinesView(false);
    }

    function handleFileSelect(event) {
        const file = event.target.files[0];
        setTimeLine(0)
        reader.onload = handleFileLoad;
        const date = file.lastModifiedDate
        if (reader.readyState === 0) {
            reader.readAsText(file);
        } else if (reader.readyState == 1) {
        } else {
            alert("No se ha cargado NINGUN Proyecto")
        }
    }
    function handleFileLoad(event) {
        let project = event.target.result
        project = JSON.parse(project)
        dispatch(cargarProyecto({ project }))
    }

    const saveSwal = () => {
        Swal.fire({
            title: '¿Deseas Guardar el proyecto antes?',
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: 'Guardar y Cerrar',
            denyButtonText: 'Cerrar SIN guardar',
            icon: 'question',
        }).then((result) => {
            //Create Element link to redirect Main Area
            const link = document.createElement("a")
            link.href = "/"
            if (result.isConfirmed) {
                //Save the project
                handleSave()
                //Redirected to Main Area with click
                link.click()
            } else if (result.isDenied) {
                //Redirected to Main Area with click
                link.click()
            }
        })
    }
    // Revisar si está marcado el campo para mostrar el datepicker.
    let isChecked = false;

    //Save the project to the computer in a JSON file
    const handleSave = () => {
        //Transform the project into a string
        const jsonProject = JSON.stringify(project)
        //Create the blob (Binary Large Object), addign the stringed jsonProject and put the type of
        const blob = new Blob([jsonProject], { type: 'application/json' })
        //Create a URL object for the blob
        const url = URL.createObjectURL(blob)
        // Create a link (a) html element for give that the url of the blob that have the 
        // stringed project information and later put the archive_name in the "download" property 
        // and later call the .click() metodh for do the download
        const a = document.createElement("a")
        a.href = url
        let date = new Date()
        a.download = `${project.projectName}-${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}.json`
        a.click()
    }

    //Export project to a JSON file with the VISIONE format
    const handleExport = () => {
        const visoProject = {
            name: project.projectName,
            text: project.text,
        }
        //Transform the project into a string
        const jsonProject = JSON.stringify(visoProject)
        //Create the blob (Binary Large Object), addign the stringed jsonProject and put the type of
        const blob = new Blob([jsonProject], { type: 'application/json' })
        //Create a URL object for the blob
        const url = URL.createObjectURL(blob)
        // Create a link (a) html element for give that the url of the blob that have the 
        // stringed project information and later put the archive_name in the "download" property 
        // and later call the .click() metodh for do the download
        const a = document.createElement("a")
        a.href = url
        a.download = `VISONE_${visoProject.name}.json`
        a.click()
    }

    return (
        <div>
            <ul className="nav nav-pills" style={{ height: '8vh', backgroundColor: 'navy', alignContent: 'center' }}>

                <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-expanded="false" >Opciones</a>
                    <ul className="dropdown-menu" style={{ backgroundColor: '#0d6efd' }}>
                        <li><Link className="dropdown-item" onClick={saveSwal}><VscNewFolder /> Nuevo Proyecto</Link></li>
                        <li><Link className="dropdown-item" onClick={() => {
                            Swal.fire({
                                title: '¿Desea Guardar el proyecto antes de CARGAR OTRO?',
                                showCancelButton: true,
                                showDenyButton: true,
                                confirmButtonText: 'Guardar y Cargar otro',
                                denyButtonText: 'Cargar otro SIN guardar',
                                icon: 'question',
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    //Save the project
                                    handleSave()
                                    //Load project from de Computer data
                                    document.getElementById("file-input").click()
                                } else if (result.isDenied) {
                                    //Load project from de Computer data
                                    document.getElementById("file-input").click()
                                }
                            })
                        }}><ImFolderUpload /> Cargar Proyecto</Link></li>
                        <li><Link className="dropdown-item" onClick={handleExport}><FaFileExport /> Exportar Proyecto</Link></li>
                        <li><Link className="dropdown-item" to="#" onClick={saveSwal} ><FaWindowClose /> Cerrar Proyecto</Link></li>
                        <input type='file' accept='.json' multiple={false} id="file-input" style={{ display: 'none' }} onChange={handleFileSelect} />
                    </ul>
                </li>

                <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-expanded="false" >Herramientas</a>
                    <ul className="dropdown-menu" style={{ backgroundColor: '#0d6efd' }}>

                        <li><a className="dropdown-item" href="#" onClick={() => {
                            Swal.fire({
                                // Nombre del Momento
                                title: 'Establecer nombre del Momento',
                                input: 'text',
                                html: '<div> <span>Agregar Fecha: </span> <input id="checkbox" type="checkbox" /> </div>',
                                focusConfirm: false,
                                inputValue: timeLineName,
                                showCancelButton: true,
                                confirmButtonText: 'Aceptar',
                                cancelButtonText: 'Cancelar',
                                preConfirm: () => {
                                    return [
                                        isChecked = document.getElementById('checkbox').checked
                                    ]
                                },
                                inputValidator: (value) => {
                                    if (!value) {
                                        return 'Hey... El campo no puede estar vacío'
                                    } else {
                                        timeLineName = value //Nombre del momento
                                        isChecked = document.getElementById('checkbox').checked
                                        if (!isChecked) {
                                            // AGREGAR LOGICA PARA PERSONALIZACIÓN
                                            // 
                                            Swal.fire({
                                                title: 'Asignar figura geométrica al Momento',
                                                input: 'select',
                                                inputOptions: {
                                                    1: 'Círculo',
                                                    2: 'Elipse',
                                                    3: 'Base de Datos',
                                                    4: 'Caja',
                                                    5: 'Rombo',
                                                    6: 'Punto',
                                                    7: 'Cuadrado',
                                                    8: 'Triángulo',
                                                    9: 'Triángulo hacia abajo',
                                                    10: 'Estrella',
                                                    11: 'Hexágono',
                                                },
                                                inputPlaceholder: 'Selecciona una figura',
                                                focusConfirm: false,
                                                showCancelButton: true,
                                                confirmButtonText: 'Siguiente',
                                                cancelButtonText: 'Cancelar',
                                                inputValidator: (value) => {
                                                    if (!value) {
                                                        return 'Hey... El campo no puede estar vacío'
                                                    } else {
                                                        shape = setShapeByValue(value)
                                                        Swal.fire({
                                                            title: 'Bordes',
                                                            input: "radio",
                                                            inputOptions: {
                                                                0: 'Continuos',
                                                                1: 'Punteados'
                                                            },
                                                            // inputPlaceholder: 'Selecciona una figura',
                                                            focusConfirm: false,
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Siguiente',
                                                            cancelButtonText: 'Cancelar',
                                                            inputValidator: (value) => {
                                                                if (!value) {
                                                                    return 'Hey... El campo no puede estar vacío'
                                                                } else {
                                                                    individualStatus = value
                                                                    Swal.fire({
                                                                        title: 'Elegir un Color',
                                                                        html: '<input id="colorP" type="color"/>',
                                                                        inputLabel: 'Color',
                                                                        focusConfirm: false,
                                                                        confirmButtonText: 'Siguiente',
                                                                        cancelButtonText: 'Cancelar',
                                                                        preConfirm: () => {
                                                                            return [
                                                                                document.getElementById('colorP').value
                                                                            ]
                                                                        }
                                                                    }).then((result => {
                                                                        let indLeng = maxLengthPriority - 1
                                                                        let positionX_Momento = 0
                                                                        if (indLeng == -1) {
                                                                            positionX_Momento = 100
                                                                        } else {
                                                                            positionX_Momento = (indLeng * 100) / 2;
                                                                        }

                                                                        if (individualStatus == 1) {
                                                                            borderDashes = true
                                                                        }

                                                                        dispatch(agregarLineaTemporal({ timeLineID: timeLineID, label: timeLineName, timeLineName: timeLineName, shape: shape, color: result.value[0], status: individualStatus, shapeProperties: { borderDashes: borderDashes }, x: positionX_Momento, y: -200, date: "" }))
                                                                        const Toast = Swal.mixin({
                                                                            toast: true,
                                                                            position: 'top-end',
                                                                            showConfirmButton: false,
                                                                            timer: 3000,
                                                                            timerProgressBar: true,
                                                                            didOpen: (toast) => {
                                                                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                                                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                                                                            }
                                                                        })

                                                                        Toast.fire({
                                                                            icon: 'success',
                                                                            title: 'Momento creado con éxito'
                                                                        })
                                                                        dispatch(agregarNodoDeLineaTemporal({ timeLineID: timeLineID, label: timeLineName, timeLineName: timeLineName, shape: shape, color: result.value[0], status: individualStatus, shapeProperties: { borderDashes: borderDashes }, x: positionX_Momento, y: -200, date: "", type: "momento" }))
                                                                        return
                                                                    }))

                                                                }
                                                            }
                                                        })
                                                    }
                                                }
                                            })
                                        } else {
                                            Swal.fire({
                                                // Nombre del Momento
                                                title: 'Establecer fecha al Momento',
                                                inputLabel: '(Opcional)',
                                                html: '<input id="datepicker" type="date">',
                                                focusConfirm: false,
                                                showCancelButton: true,
                                                confirmButtonText: 'Aceptar',
                                                cancelButtonText: 'Cancelar',
                                                preConfirm: () => {
                                                    return [
                                                        document.getElementById('datepicker').value
                                                    ]
                                                }
                                            }).then((result => {
                                                if (result.value[0] === "") {
                                                    Swal.fire({
                                                        icon: 'error',
                                                        title: 'No se agregó una fecha valida'
                                                    });
                                                } else {
                                                    let fecha = result.value[0]
                                                    // AGREGAR LOGICA PARA PERSONALIZACIÓN
                                                    // 

                                                    Swal.fire({
                                                        title: 'Asignar figura geométrica',
                                                        input: 'select',
                                                        inputOptions: {
                                                            1: 'Círculo',
                                                            2: 'Elipse',
                                                            3: 'Base de Datos',
                                                            4: 'Caja',
                                                            5: 'Rombo',
                                                            6: 'Punto',
                                                            7: 'Cuadrado',
                                                            8: 'Triángulo',
                                                            9: 'Triángulo hacia abajo',
                                                            10: 'Estrella',
                                                            11: 'Hexágono',
                                                        },
                                                        inputPlaceholder: 'Selecciona una figura',
                                                        focusConfirm: false,
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Siguiente',
                                                        cancelButtonText: 'Cancelar',
                                                        inputValidator: (value) => {
                                                            if (!value) {
                                                                return 'Hey... El campo no puede estar vacío'
                                                            } else {
                                                                shape = setShapeByValue(value)
                                                                Swal.fire({
                                                                    title: 'Elegir un Color',
                                                                    html: '<input id="colorP" type="color"/>',
                                                                    inputLabel: 'Color',
                                                                    focusConfirm: false,
                                                                    confirmButtonText: 'Siguiente',
                                                                    cancelButtonText: 'Cancelar',
                                                                    preConfirm: () => {
                                                                        return [
                                                                            document.getElementById('colorP').value
                                                                        ]
                                                                    }
                                                                }).then((result => {
                                                                    let indLeng = maxLengthPriority - 1
                                                                    let positionX_Momento = (indLeng * 100) / 2;
                                                                    if (individualStatus == 1) {
                                                                        borderDashes = true
                                                                    }
                                                                    dispatch(agregarLineaTemporal({ timeLineID: timeLineID, label: timeLineName, timeLineName: timeLineName, shape: shape, color: result.value[0], status: individualStatus, shapeProperties: { borderDashes: borderDashes }, x: positionX_Momento, y: -200, date: fecha }))
                                                                    const Toast = Swal.mixin({
                                                                        toast: true,
                                                                        position: 'top-end',
                                                                        showConfirmButton: false,
                                                                        timer: 3000,
                                                                        timerProgressBar: true,
                                                                        didOpen: (toast) => {
                                                                            toast.addEventListener('mouseenter', Swal.stopTimer)
                                                                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                                                                        }
                                                                    })

                                                                    Toast.fire({
                                                                        icon: 'success',
                                                                        title: 'Momento creado con éxito'
                                                                    })
                                                                    dispatch(agregarNodoDeLineaTemporal({ timeLineID: timeLineID, label: timeLineName, timeLineName: timeLineName, shape: shape, color: result.value[0], status: individualStatus, shapeProperties: { borderDashes: borderDashes }, x: positionX_Momento, y: -200, date: "" }))
                                                                    return
                                                                }))
                                                            }
                                                        }
                                                    })
                                                }
                                            }))
                                        }
                                    }
                                }
                            }
                            )
                        }}><FaPlusCircle /> Nuevo Momento</a></li>

                        <li><a className="dropdown-item" href="#" onClick={() => {
                            if (individuos.length === 0) {
                                Swal.fire({
                                    title: 'Aún no hay individuos',
                                    icon: 'info',
                                });
                            } else {
                                openOverlayGetionPersonas()
                            }
                        }}
                        ><IoPersonCircleOutline /> Gestión de individuos</a></li>

                        <li><a className="dropdown-item" href="#" onClick={() => {
                            if (!objects) {
                                Swal.fire({
                                    title: 'Aún no hay objetos',
                                    icon: 'info',
                                });
                            } else {
                                openOverlayGetionObjetos()
                            }
                        }}
                        ><FaBoxes /> Gestión de Objetos </a></li>

                        <li><a className="dropdown-item" href="#" onClick={() => {

                            // if (tlPlace != "" || genPlaces != []) {
                            Swal.fire({
                                title: '¿Cambiar el Campo Relacional del Momento?',
                                text: "Puede cambiarlo o agregar uno nuevo",
                                icon: 'info',
                                showDenyButton: true,
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'Nuevo Campo Relacional',
                                denyButtonText: 'Campo Relacional Existente'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    Swal.fire({
                                        // TL Place name
                                        title: 'Establecer nombre del Campo Relacional',
                                        input: 'text',
                                        inputPlaceholder: 'Nombre del Campo Relacional',
                                        focusConfirm: false,
                                        inputValue: tlPlaceInput,
                                        showCancelButton: true,
                                        confirmButtonText: 'Agregar',
                                        cancelButtonText: 'Cancelar',
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Hey... El campo no puede estar vacío'
                                            } else {
                                                tlPlaceInput = value
                                                if (!(genPlaces).includes(tlPlaceInput)) {
                                                    // AGREGAR LOGICA PARA PERSONALIZACIÓN
                                                    // 
                                                    Swal.fire({
                                                        title: 'Bordes',
                                                        input: "radio",
                                                        inputOptions: {
                                                            0: 'Continuos',
                                                            1: 'Punteados'
                                                        },
                                                        // inputPlaceholder: 'Selecciona una figura',
                                                        focusConfirm: false,
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Siguiente',
                                                        cancelButtonText: 'Cancelar',
                                                        inputValidator: (value) => {
                                                            if (!value) {
                                                                return 'Hey... El campo no puede estar vacío'
                                                            } else {
                                                                individualStatus = value
                                                                Swal.fire({
                                                                    title: 'Elegir un Color',
                                                                    html: '<input id="colorP" type="color"/>',
                                                                    inputLabel: 'Color',
                                                                    focusConfirm: false,
                                                                    confirmButtonText: 'Siguiente',
                                                                    cancelButtonText: 'Cancelar',
                                                                    preConfirm: () => {
                                                                        return [
                                                                            document.getElementById('colorP').value
                                                                        ]
                                                                    }
                                                                }).then((result => {
                                                                    let indLeng = maxLengthPriority - 1
                                                                    let positionX_Momento = 0
                                                                    if (indLeng == -1) {
                                                                        positionX_Momento = 100
                                                                    } else {
                                                                        positionX_Momento = (indLeng * 100) / 2;
                                                                    }
                                                                    if (individualStatus == 1) {
                                                                        borderDashes = true
                                                                    }
                                                                    dispatch(agregarNodoDeCampoRelacional({ timeLineID: timeLineID, label: tlPlaceInput, shape: shape, color: result.value[0], x: positionX_Momento, y: -100, status: individualStatus, shapeProperties: { borderDashes: borderDashes } }))
                                                                    dispatch(addTimeLinePlace({ timeLineID: timeLineID, tlPlace: tlPlaceInput }));

                                                                    const Toast = Swal.mixin({
                                                                        toast: true,
                                                                        position: 'top-end',
                                                                        showConfirmButton: false,
                                                                        timer: 3000,
                                                                        timerProgressBar: true,
                                                                        didOpen: (toast) => {
                                                                            toast.addEventListener('mouseenter', Swal.stopTimer)
                                                                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                                                                        }
                                                                    })

                                                                    Toast.fire({
                                                                        icon: 'success',
                                                                        title: 'Campo Relacional creado con éxito'
                                                                    })
                                                                    // dispatch(agregarNodoDeCampoRelacional({ timeLineID: timeLineID, label: tlPlaceInput, shape: shape, color: result.value[0], x: positionX_Momento, y: -100, status: individualStatus, shapeProperties: { borderDashes: borderDashes } }))
                                                                }))
                                                            }
                                                        }
                                                    })
                                                } else {
                                                    Swal.fire({
                                                        title: 'Ya existe este Campo Relacional',
                                                        icon: 'info',
                                                    });
                                                }
                                            }
                                        }
                                    })
                                } else if (result.isDenied) {
                                    Swal.fire({
                                        title: 'Escoger Campo Relacional exitente',
                                        input: 'select',
                                        inputOptions: genPlaces,
                                        inputPlaceholder: 'Selecciona un Campo Relacional',
                                        focusConfirm: false,
                                        showCancelButton: true,
                                        confirmButtonText: 'Siguiente',
                                        cancelButtonText: 'Cancelar',
                                        inputValidator: (value) => {
                                            if (!value) {
                                                Swal.fire({
                                                    title: 'No escogió un Campo Relacional válido',
                                                    icon: 'error',
                                                });
                                            } else {
                                                let placeIn = genPlaces[value]
                                                let indLeng = maxLengthPriority - 1
                                                let positionX_Momento = 0
                                                if (indLeng == -1) {
                                                    positionX_Momento = 100
                                                } else {
                                                    positionX_Momento = (indLeng * 100) / 2;
                                                }
                                                if (individualStatus == 1) {
                                                    borderDashes = true
                                                }
                                                dispatch(agregarNodoDeCampoRelacional({ timeLineID: timeLineID, label: placeIn, shape: shape, color: result.value[0], x: positionX_Momento, y: -100, status: individualStatus, shapeProperties: { borderDashes: borderDashes } }))
                                                dispatch(addTimeLinePlace({ timeLineID: timeLineID, tlPlace: placeIn }))
                                            }
                                        }
                                    })
                                }
                            })
                            // }
                        }
                        }> <MdPlace /> Campo Relacional del Momento</a></li>

                        <li><a className="dropdown-item" href="#" onClick={() => {
                            if (timeLines.length == 1) {
                                Swal.fire({
                                    title: 'Aún no hay suficientes Momentos para cargar',
                                    icon: 'info',
                                });
                            } else {
                                openOverlayTotalTimeLines()
                            }
                        }}
                        ><AiOutlineFundProjectionScreen /> Vista general del proyecto</a></li>
                    </ul>
                </li>
            </ul >
            {showOverlay && <ModalOverlayGestionPersonas timeLineID={timeLineID} onClose={closeOverlay} />
            }
            {showOverlayObj && <ModalOverlayGestionObjetos timeLineID={timeLineID} onClose={closeOverlayObj} />}
            {showOverlayTotalTimeLinesView && <TotalTimelineslView onClose={closeOverlayTotalTimeLines} />}
        </div >
    )
}
